module.exports = __webpack_public_path__ + "img/fb-patent.62dbe801.svg";